import { useCallback } from 'react';

import { useTrackCommentModeToggledOff, useTrackCommentModeToggledOn } from '@air/analytics';

import { useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';

export const useAnnotationsToggle = () => {
  const isAnnotationsEnabled = useAnnotationV2Store((state) => state.isAnnotationsEnabled);
  const setAnnotationsEnabled = useAnnotationV2Store((state) => state.setAnnotationsEnabled);
  const setAnnotations = useAnnotationV2Store((state) => state.setAnnotations);
  const focusCommentInput = useAnnotationV2Store((state) => state.focusCommentInput);
  const cancelPendingCommentInputFocus = useAnnotationV2Store((state) => state.cancelPendingCommentInputFocus);
  const { trackCommentModeToggledOff } = useTrackCommentModeToggledOff();
  const { trackCommentModeToggledOn } = useTrackCommentModeToggledOn();

  const showAnnotations = useCallback(() => {
    trackCommentModeToggledOn();
    setAnnotationsEnabled(true);

    // only focus on the actual off→on transition, so re-invocations (e.g. the pencil shortcut
    // switching tools while already in comment mode) don't steal focus
    if (!isAnnotationsEnabled) {
      focusCommentInput('panel');
    }
  }, [isAnnotationsEnabled, setAnnotationsEnabled, trackCommentModeToggledOn, focusCommentInput]);

  const hideAnnotations = useCallback(() => {
    trackCommentModeToggledOff();
    setAnnotationsEnabled(false);

    setAnnotations([]);

    // drop any queued focus request — a focus stored while the comments panel was closed
    // would otherwise fire whenever the panel later mounts
    cancelPendingCommentInputFocus();
  }, [setAnnotationsEnabled, trackCommentModeToggledOff, setAnnotations, cancelPendingCommentInputFocus]);

  return {
    isAnnotationsEnabled,
    showAnnotations,
    hideAnnotations,
  };
};
